import { fontList } from '../../core/font-list';
import {colorListPairs, colorMap,colorListCharts} from '../../core/color-list';

export let params = {
  'category': 'animation',
  'parameters': {
    'size': {
      'default': {
        'key': '600 x 600',
        'value': [600, 600],
        'label': '600 x 600'
      },
      'label': 'Afmeting',
      'type': 'array',
      'values': [
        {
          'key': '1500 x 1500',
          'value': [1500, 1500],
          'label': '1500 x 1500'
        },
        {
          'key': '1200 x 1200',
          'value': [1200, 1200],
          'label': '1200 x 1200'
        },
        {
          'key': '900 x 900',
          'value': [900, 900],
          'label': '900 x 900'
        },
        {
          'key': '600 x 600',
          'value': [600, 600],
          'label': '600 x 600'
        },
        {
          'key': '400 x 400',
          'value': [400, 400],
          'label': '400 x 400'
        },
        {
          'key': '300 x 300',
          'value': [300, 300],
          'label': '300 x 300'
        },
      ],
      'control': 'standard-select',
      'description': 'Afmeting van de visualisatie',
    },
    'width': {
      'default': 600,
      'label': 'Breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'height': {
      'default': 600,
      'label': 'Hoogte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'text': {
      'default': 'Appels met peren vergelijken.\n' +
      '\n' +
      'Appels en peren bevatten\n' +
      'veel vitaminen en mineralen.\n' +
      '\n' +
      'In peren zitten 20% van de aanbevolen\n' +
      'dagelijkse hoeveelheid vezels, \n' +
      'tegenover 10% in appels.',
      'label': 'Tekst',
      'type': 'string',
      'control': 'standard-textarea',
    },
    'textFontSize': {
      'default': 32,
      'label': 'Font grootte tekst',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'textLineHeight': {
      'default': 1.3,
      'label': 'Regelhoogte tekst',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'textFontColor': {
      'default': colorMap.grijsDonker,
      'label': 'Font kleur tekst',
      'type': 'string',
      'control': 'standard-control',
    },
    'colorScheme': {
      'default': {
        'key': 'grijs',
        'label': 'Grijs',
        'value': [colorMap.grijsLicht, colorMap.grijsDonker],
      },
      'control': 'cbs-color-scheme',
    },
    'marginLeft': {
      'default': 20,
      'label': 'Linkermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginRight': {
      'default': 20,
      'label': 'Rechtermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginTop': {
      'default': 80,
      'label': 'Bovenmarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginBottom': {
      'default': 120,
      'label': 'Ondermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'cbsLogoY': {
      'default': 60,
      'label': 'Logo Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'cbsLogoWidth': {
      'default': 240,
      'label': 'Breedte CBS logo',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'cbsLogoColor': {
      'default': '#00B3D5',
      'label': 'Kleur logo',
      'type': 'string',
      'control': 'standard-number',
    },
    'cbsPayoffY': {
      'default': 500,
      'label': 'Payoff Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'cbsPayoffFontSize': {
      'default': 42,
      'label': 'Font grootte payoff',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'cbsPayoffFontColor': {
      'default': '#0058b8',
      'label': 'Kleur payoff',
      'type': 'string',
      'control': 'standard-number',
    },
    'backgroundBorderRadius': {
      'default': 15,
      'label': 'Achtergrond rand radius',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleOffsetX': {
      'default': 17,
      'label': 'Titel afstand X',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'title1OffsetY': {
      'default': 40,
      'label': 'Titel 1 afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'title2OffsetY': {
      'default': 78,
      'label': 'Titel 2 afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleText1': {
      'default': 'Lorem ipsum dolor sit amet',
      'label': 'Titel tekst 1',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleText2': {
      'default': 'consectetur adipiscing elit',
      'label': 'Titel tekst 2',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleColor': {
      'default': '#FFFFFF',
      'label': 'Titel kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleFontSize': {
      'default': 32,
      'label': 'Titel font grootte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleFontWeight': {
      'default': 500,
      'label': 'Titel font dikte',
      'type': 'numeric',
      'control': 'standard-control',
    },
    'minY': {
      'default': 0,
      'label': 'Min Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'maxY': {
      'default': 100,
      'label': 'Max Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'steps': {
      'default': 2,
      'label': 'Steps',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Aantal horizontale lijnen excl. as',
    },
    'unitText': {
      'default': 'unit',
      'label': 'Tekst eenheid',
      'type': 'string',
      'control': 'standard-control',
    },
    'unitTextOffsetY': {
      'default': 35,
      'label': 'Afstand unit boven max',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelSpaceY': {
      'default': 60,
      'label': 'Label ruimte Y',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Ruimte voor de labelteksten langs de Y-as',
    },
    'labelSpaceX': {
      'default': 20,
      'label': 'Label ruimte X',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelColor': {
      'default': '#7f7f7f',
      'label': 'Label kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelFontSize': {
      'default': 30,
      'label': 'Label font grootte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelOffsetY': {
      'default': 10,
      'label': 'Label afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand tussen de labels en de Y-as',
    },
    'labelOffsetX': {
      'default': 15,
      'label': 'Label afstand X',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legend': {
      'default': true,
      'label': 'Show legend',
      'type': 'boolean',
      'control': 'standard-checkbox',
    },
    // 'legendRows': {
    //   'default': 1,
    //   'label': 'Aantal rijen in de legend',
    //   'type': 'numeric',
    //   'control': 'standard-number',
    // },
    'legendItemWidth' : {
      'default': 30,
      'label': 'Breede van het legend item',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Is de breede van het ledgend item voor de tekst',
    },
    'legendOffsetY' : {
      'default': 80,
      'label': 'Y offset legenda',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Offset van de legends naar de grafiek erboven',
    },
    'legendSpaceBetweenColumns' : {
      'default': 180,
      'label': 'Breede legenda',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendItemDistance' : {
      'default': 30,
      'label': 'Afstand tussen de legenda items',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendFontSize' : {
      'default': 25,
      'label': 'Lettergrotte in de legenda',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'ledgendSpaceBetweenItemAndText':{
      'default': 5,
      'label': 'Afstand tussen item en tekst in legenda',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'formatLocale': {
      'default': {
        'key': 'nl-nl',
        'value': 'nl-nl',
        'label': 'Nederlands'
      },
      'label': 'Taal',
      'type': 'string',
      'values' : [
        {
          'key': 'nl-nl',
          'value': 'nl-nl',
          'label': 'Nederlands'
        },
        {
          'key': 'en-gb',
          'value': 'en-gb',
          'label': 'Engels'
        }
      ],
      'control': 'standard-select',
      'description': 'Taal voor het formatteren van de Y-as labels',
    },
    'labelDecimalsY': {
      'default': '0',
      'label': 'Label decimalen y',
      'type': 'number',
      'control': 'standard-number',
      'description': 'Aantal cijfers achter de komma in de Y-as labels',
    },
    'leftLabelX': {
      'default': 'Start',
      'label': 'Linker label X',
      'type': 'string',
      'control': 'standard-control',
    },
    'rightLabelX': {
      'default': 'End',
      'label': 'Rechter label X',
      'type': 'string',
      'control': 'standard-control',
    },
    'axisStroke': {
      'default': '#FFFFFF',
      'label': 'As kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'axisStrokeWidth': {
      'default': 3,
      'label': 'As breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'lineStrokes': {
      'default': colorListCharts,
      'label': 'Lijn kleuren',
    },
    'lineStrokeWidth': {
      'default': 5,
      'label': 'Lijn breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'lineJoin': {
      'default': {
        'key': 'miter',
        'value': 'miter',
        'label': 'Punt'
      },
      'label': 'Lijn aansluiting',
      'type': 'string',
      'values': [
        {
          'key': 'miter',
          'value': 'miter',
          'label': 'Punt'
        },
        {
          'key': 'round',
          'value': 'round',
          'label': 'Afgerond'
        }
      ],
      'control': 'standard-select',
      'description': 'Wijze waarop de lijnaasluitingen worden getekend',
    },
    'icon': {
      'default': '13A',
      'control': 'cbs-svg-icon',
    },
    'iconShow': {
      'default': true,
      'label': 'Show icoon',
      'type': 'boolean',
      'control': 'standard-checkbox',
    },
    'iconWidth': {
      'default': 140,
      'label': 'Icoon breedte',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Breedte van het icoon',
    },
    'iconStrokeWidth': {
      'default': 3,
      'label': 'Icoon font dikte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'iconOffsetDeltaX': {
      'default': 0,
      'label': 'Icoon afstand delta X',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Verschuiving van het icoon in de x-richting',
    },
    'iconOffsetDeltaY': {
      'default': 0,
      'label': 'Icoon afstand delta Y',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Verschuiving van het icoon in de x-richting',
    },
    'iconOffsetX': {
      'default': 440,
      'label': 'Icoon afstand X',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand van het icoon t.o.v. de linkerkant',
    },
    'iconOffsetY': {
      'default': 35,
      'label': 'Icoon afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand van het icoon t.o.v. de bovenkant',
    },
  },
  'timings': {
    'pauseSlide1': {
      'default': 3,
      'label': 'Pause tussen de slides',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseSlide2': {
      'default': 8,
      'label': 'Pause slide 2',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide1Animation': {
      'default': 8,
      'label': 'Slide 1 animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide2Animation': {
      'default': 1,
      'label': 'Slide 2 animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'logoCBSAnimation': {
      'default': 1,
      'label': 'Logo CBS animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'payoffCBSAnimation': {
      'default': 1,
      'label': 'Payoff CBS animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseCBS': {
      'default': 1,
      'label': 'Pause met logo CBS',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseEnd': {
      'default': 3,
      'label': 'Pause aan het einde',
      'type': 'numeric',
      'control': 'standard-number'
    }
  },
  'data': {
    'values': [['Peren', 'Appels', 'Pruimen'], [76, 45, 10], [67, 53, 10], [51, 54, 10], [42, 61, 10], [51, 69, 10], [69, 75, 19], [67,73,20]],
    'columnLimitMin': 1,
    'columnLimitMax': 4,
    'columnLabelNumber': 1,
    'rowLimitMin': 2,
    'rowLimitMax': 100,
    'rowLabelNumber': 0,
  },
  'parameterGroups': [
    {
      'title': 'Primair',
      'collapsed': false,
      'keys': ['size','icon','titleText1', 'titleText2', 'text', 'minY', 'maxY', 'unitText', 'leftLabelX', 'rightLabelX'],
    },
    {
      'title': 'Secundair',
      'collapsed': true,
      'keys': ['steps', 'formatLocale', 'labelDecimalsY', 'legendOffsetY', 'legendSpaceBetweenColumns','iconOffsetDeltaX','iconOffsetDeltaY'],
    }
  ],
  'timingGroups': [
    {
      'title': 'Timing',
      'collapsed': true,
      'keys': ['slide1Animation','pauseSlide2','logoCBSAnimation', 'payoffCBSAnimation','pauseEnd']
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/animations/triptych-line-hor-steps/social.params.ts